import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AgentsAdminLoginPage from "./auth/login/admin.login.page";
import AgentsAdminProvider from "./providers/agents-admin.provider";
import AgentsAdminHomePage from "./home/agents-admin.home.page";
import AgentsListAdminPage from "./agents/list/list-agents.page";
import PrivateAdminRoute from "./components/private-route";
import AgentEditPage from "./agents/edit/agent-edit.page";
import AgentCreatePage from "./agents/create/agent-create.page";
import AgentSponsorListAdminPage from "./sponsors/list/list-sponsors.page";
import SponsorCreatePageAdminPage from "./sponsors/create/sponsor-create.page";

const AdminRoutesPage = () => {
  return (
    <AgentsAdminProvider>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<AgentsAdminLoginPage />} />
        <Route
          path="/home"
          element={
            <PrivateAdminRoute>
              <AgentsAdminHomePage />
            </PrivateAdminRoute>
          }
        />
        <Route
          path="/agents"
          element={
            <PrivateAdminRoute>
              <AgentsListAdminPage />
            </PrivateAdminRoute>
          }
        />
        <Route
          path="/agents/:id"
          element={
            <PrivateAdminRoute>
              <AgentEditPage />
            </PrivateAdminRoute>
          }
        />
        <Route
          path="/agents/create"
          element={
            <PrivateAdminRoute>
              <AgentCreatePage />
            </PrivateAdminRoute>
          }
        />
        <Route
          path="/sponsors"
          element={
            <PrivateAdminRoute>
              <AgentSponsorListAdminPage />
            </PrivateAdminRoute>
          }
        />
        <Route
          path="/sponsors/create"
          element={
            <PrivateAdminRoute>
              <SponsorCreatePageAdminPage />
            </PrivateAdminRoute>
          }
        />
      </Routes>
    </AgentsAdminProvider>
  );
};
export default AdminRoutesPage;
